import type { RecordEffect } from "@/features/patient/records/api/dataPipelineApi";
import type { ReviewOutcome } from "@/portals/patient/api/reviewItemsApi";

/** What the clinician decided, in the patient's words. Pair and single items read differently. */
export function outcomeActionLabel(action: ReviewOutcome["action"], isPair: boolean): string {
  switch (action) {
    case "KEEP_EXISTING":
      return isPair ? "Your clinician kept your earlier record" : "Your clinician confirmed this record";
    case "ACCEPT_NEW":
      return "Your clinician accepted your newer record";
    case "BOTH_VALID":
      return "Your clinician confirmed both records";
    case "MARK_DISCONTINUED":
      return isPair ? "Your clinician marked one medicine as discontinued" : "Your clinician marked this medicine as discontinued";
    case "CORRECT_VALUE":
      return "Your clinician corrected your record";
    case "REJECT_BOTH":
      return isPair ? "Your clinician removed these records" : "Your clinician removed this record";
  }
}

export const EFFECT_LABELS: Record<RecordEffect, string> = {
  KEPT: "Kept",
  DISMISSED: "Removed from your list",
  DISCONTINUED: "Marked as discontinued",
  CORRECTED: "Corrected",
};
